export default "__VITE_ASSET__DiYikG3x__"